<template>
  <div class="radio-field">
    <label class="radio-title"> {{ lang[activeLang][input.title] }} </label>
    <div
      v-for="(option, index) in input.options"
      :key="index"
      class="radio-container"
    >
      <input
        :id="`${inputKey}_${index}`"
        v-model="selectedValue"
        :value="option"
        :name="inputKey"
        class="input-radio"
        type="radio"
        @change="inputUpdate(input)"
      >
      <label
        :for="`${inputKey}_${index}`"
        class="radio-label"
      >{{ (lang[activeLang][option] && lang[activeLang][option]) || option }}<em v-if="input.required">*</em></label>
    </div>
    <label
      v-if="input.hasError && input.requiredError"
      class="error-text"
    >
      {{ lang[activeLang]['This field is required.'] }}</label>
    <label
      v-else-if="input.hasError && input.errorMsg"
      class="error-text"
    >{{
      lang[activeLang][input.errorMsg]
    }}</label>
  </div>
</template>

<script>
export default {
  name: 'FormRadio',
  props: {
    formData: {
      type: Object,
      default: new Object()
    },
    activeLang: {
      type: String,
      default: 'English'
    },
    input: {
      type: Object,
      required: true
    },
    inputKey: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedValue: null,
    }
  },
  created() {
    this.selectedValue = this.formData[this.input.index] || null
  },
  methods: {
    inputUpdate: function(input) {
      // Send the new value up to the parent.
      this.$emit('formUpdate', this.selectedValue)

      // If there's no error, don't perform a valid check.
      if (!input.hasError) return

      // A selection has been made, remove the requiredError.
      if (this.selectedValue) {
        input.requiredError = false
      }

      // If it had a validation error, validate again.
      if (input.errorMsg && input.isValid && input.isValid(this.selectedValue)) {
        input.errorMsg = null
      }

      // If there's no validation or required error, remove hasError.
      if (!input.errorMsg || !input.requiredError) {
        input.hasError = false
      }
    }
  }
}
</script>

<style scoped>
.radio-field {
  width: 100%;
  margin-top: 1em;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  border: 1px;
  border-style: solid;
  border-color: #d4d6de;
  padding: 18px 1em;
  flex-wrap: nowrap;
}

.radio-title {
  text-align: left;
  display: block;
  color: rgb(102, 102, 102);
}

.radio-container {
  padding-top: .5em;
  width: 100%;
  display: flex;
  align-items: center;
}

.radio-label {
  margin-left: .5em;
  text-align: left;
  color: rgb(102, 102, 102);
}

@media screen and (min-width: 900px) {
  .field-radio {
    width: 45%;
  }
}

.error-text {
  color: red;
  font-size: 0.85em;
  margin-top: 0.5em;
}
</style>